export const invitationAddress = {
    namespaced: true
};
